import { Component, AfterViewInit } from '@angular/core';

declare var jQuery: any;


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})

export class AppComponent {}



// WEBPACK FOOTER //
// ./src/app/app.component.ts